// Translations for the applicant portal (/ziadost)
export const PT = {
  sk: {
    brand: "Portál certifikácie Sa.Eko.",
    register: "Registrácia uchádzača",
    login: "Prihlásenie",
    tabLogin: "Prihlásiť sa",
    tabRegister: "Registrovať sa",
    nameLabel: "Meno / Názov firmy",
    typeLabel: "Typ uchádzača",
    individual: "Jednotlivec",
    company: "Firma",
    individualHint: "SZČO / fyzická osoba",
    companyHint: "s.r.o. / právnická osoba",
    switchTypeTitle: "Typ účtu",
    switchTypeHint: "Zaregistrovali ste sa omylom ako firma alebo jednotlivec? Tu si to môžete opraviť.",
    switchToCompany: "Prepnúť na Firmu",
    switchToIndividual: "Prepnúť na Jednotlivca",
    switchTypeCurrent: "Aktuálny typ:",
    switchTypeConfirm: "Naozaj chcete zmeniť typ účtu? Prispôsobia sa tomu polia žiadosti aj poplatok.",
    switchTypeLocked: "Typ účtu už nie je možné zmeniť (žiadosť je uhradená alebo schválená). Kontaktujte kontakt@saubereko.eu.",
    switchTypeDone: "Typ účtu bol zmenený.",
    switchTypeErr: "Typ účtu sa nepodarilo zmeniť.",
    email: "E-mail",
    password: "Heslo",
    consentPre: "Súhlasím so spracovaním mojich osobných údajov spoločnosťou SauberEko s.r.o. za účelom certifikačného konania a komunikácie. (",
    privacy: "Ochrana údajov",
    createAccount: "Vytvoriť konto",
    enter: "Vstúpiť",
    working: "Pracujem...",
    loginError: "Chyba pri prihlásení.",
    logout: "Odhlásiť",
    dangerTitle: "Zmazať účet",
    dangerHint: "V súlade s GDPR (právo na výmaz) môžete natrvalo zmazať svoj účet a všetky súvisiace údaje — žiadosť, nahraté súbory, podpísané dokumenty, faktúry a korešpondenciu. Táto akcia je nevratná.",
    deleteBtn: "Zmazať môj účet",
    deleteConfirmTitle: "Natrvalo zmazať účet?",
    deleteConfirmText: "Zmaže sa celý Váš účet a všetky údaje. Túto akciu nie je možné vrátiť späť. Pre potvrdenie napíšte nižšie slovo",
    deleteConfirmWord: "ZMAZAŤ",
    deleteTypePlaceholder: "Napíšte ZMAZAŤ",
    deleteCancel: "Zrušiť",
    deleteConfirmBtn: "Natrvalo zmazať",
    deleteDone: "Váš účet bol zmazaný. Ďakujeme.",
    deleteErr: "Zmazanie zlyhalo. Skúste to znova.",
    // status
    stSubmitted: "Žiadosť podaná",
    stApproved: "Schválená",
    stPaid: "Poplatok uhradený",
    evidenceNo: "Evidenčné číslo:",
    auditConfirmed: "Audit dokončený — schválené",
    certifiedBadge: "Certifikát vydaný — ste certifikovaný",
    // payment
    feeTitle: "Registračný poplatok",
    feeDesc1: "Vaša žiadosť bola schválená. Pre pokračovanie v certifikačnom konaní uhraďte jednorazový registračný poplatok ",
    feeAmount: "59,00 € (vrátane DPH 23 %)",
    feeDesc2: ". Po úhrade Vám automaticky zašleme faktúru.",
    payBtn: "Zaplatiť 59 € kartou",
    feeAmountCompany: "490,00 € (vrátane DPH 23 %)",
    payBtnCompany: "Zaplatiť 490 € kartou",
    redirecting: "Presmerúvam na platbu...",
    verifying: "Overujem platbu...",
    paySuccess: "Platba bola úspešná! Faktúra Vám bola odoslaná e-mailom.",
    payFailed: "Platbu sa nepodarilo overiť. Skontrolujte e-mail alebo skúste znova.",
    payExpired: "Platba vypršala. Skúste to znova.",
    paidNote: "Registračný poplatok je uhradený. Faktúru si môžete stiahnuť.",
    downloadInvoice: "Stiahnuť faktúru (PDF)",
    invoiceErr: "Faktúru sa nepodarilo načítať.",
    docsTitle: "Dokumenty na stiahnutie",
    docsHint: "Vyplnené dokumenty pošlite na info@saubereko.eu — alebo ich nahrajte nižšie.",
    docPostup: "Postup certifikácie",
    docZiadost: "Žiadosť o certifikáciu",
    docKodex: "Kódex profesijnej integrity",
    docSuhlas: "Súhlas so spracúvaním údajov (GDPR)",
    docDownload: "Stiahnuť",
    // application form
    appTitle: "Žiadosť o začatie certifikačného procesu",
    appSubtitle: "Sa.Eko. — vyplňte údaje a odošlite žiadosť na posúdenie.",
    sec1: "1. Identifikačné údaje",
    sec2: "2. Oblasť pôsobenia a špecializácia",
    sec3: "3. Technické a odborné zázemie (self-audit)",
    sec4: "4. Vyhlásenie o stotožnení sa s Kódexom Sa.Eko.",
    fName: "Názov firmy",
    fNameInd: "Meno a priezvisko",
    fIco: "IČO",
    fBirth: "Dátum narodenia",
    fIcoInd: "IČO (ak ste SZČO — nepovinné)",
    fPhone: "Telefón",
    fSeat: "Sídlo",
    fAddr: "Adresa pôsobenia",
    fCountry: "Krajina (fakturácia)",
    fVatId: "IČ DPH odberateľa (pre firmy v EÚ)",
    fResponsible: "Zodpovedná osoba (kontaktné údaje)",
    fSpec: "Stručne popíšte hlavné činnosti, pre ktoré žiadate certifikáciu",
    fWorkers: "Počet pracovníkov podliehajúcich certifikácii",
    fEquip: "Zoznam kľúčového technického vybavenia",
    fCerts: "Aktuálne vlastnené certifikáty (ISO, odborné skúšky)",
    declKodex: "Potvrdzujem, že som sa v plnom rozsahu oboznámil s dokumentom „Kódex profesionálnej integrity a kvality 2026“ spoločnosti SauberEko s.r.o.",
    declAudit: "Súhlasím s vykonaním odborného auditu a preverením mojich kompetencií/procesov.",
    declPillars: "Zaväzujem sa dodržiavať 10 pilierov odbornosti a zodpovednosti Sa.Eko.",
    declUnderstanding: "Rozumiem, že certifikát Sa.Eko. je výsledkom preverenia profesionality a nie je nárokovateľný automaticky.",
    submitNew: "Uložiť a pokračovať na podpis dokumentov",
    saveChanges: "Uložiť zmeny",
    sending: "Odosielam...",
    appSavedNew: "Údaje sú uložené. Teraz podpíšte dokumenty nižšie a nakoniec odošlite kompletnú žiadosť.",
    appSavedUpd: "Žiadosť bola aktualizovaná.",
    approvedMsg: "Vaša žiadosť bola schválená a zaradená do certifikačného konania. Náš garant Vás bude kontaktovať do 14 pracovných dní.",
    regimeNonEu: "Mimo EÚ: faktúra bude vystavená bez DPH (vývoz služby).",
    regimeRc: "EÚ firma s IČ DPH: uplatní sa prenesenie daňovej povinnosti (Reverse charge).",
    regimeOss: "EÚ bez IČ DPH: uplatní sa režim OSS.",
    // uploads
    upTitle: "Dokumenty a video",
    upDesc: "Priložte podklady k žiadosti (profil/životopis, certifikáty, fotodokumentáciu) a krátke overovacie video Vašej práce.",
    upDoc: "Nahrať dokument",
    upVideo: "Nahrať video",
    upVideoReplace: "Nahradiť video",
    upDocHint: "PDF, JPG, PNG, DOCX · max 15 MB",
    upVideoHint: "MP4, MOV, WEBM · max 100 MB",
    upUploading: "Nahrávam...",
    upTooBig: "Súbor je príliš veľký",
    upFailed: "Nahrávanie zlyhalo.",
    upSubmitTitle: "Hotovo s nahrávaním?",
    upSubmitHint: "Po nahratí všetkých podkladov ich odošlite na posúdenie. Potvrdenie Vám zašleme e-mailom.",
    upSubmitBtn: "Odoslať podklady na audit",
    upSubmitting: "Odosielam...",
    upSubmitDone: "Podklady boli odoslané na posúdenie. Potvrdenie sme Vám zaslali e-mailom.",
    upSubmitErr: "Odoslanie zlyhalo. Skúste to znova.",
    confirmDelete: "Zmazať tento súbor?",
  },
  en: {
    brand: "Sa.Eko. Certification Portal",
    register: "Applicant registration",
    login: "Sign in",
    tabLogin: "Sign in",
    tabRegister: "Register",
    nameLabel: "Name / Company name",
    typeLabel: "Applicant type",
    individual: "Individual",
    company: "Company",
    individualHint: "Self-employed",
    companyHint: "Company (s.r.o. / Ltd.)",
    switchTypeTitle: "Account type",
    switchTypeHint: "Registered as a company or individual by mistake? You can correct it here.",
    switchToCompany: "Switch to Company",
    switchToIndividual: "Switch to Individual",
    switchTypeCurrent: "Current type:",
    switchTypeConfirm: "Do you really want to change the account type? Application fields and the fee will adjust accordingly.",
    switchTypeLocked: "The account type can no longer be changed (application is paid or approved). Contact kontakt@saubereko.eu.",
    switchTypeDone: "Account type changed.",
    switchTypeErr: "Could not change the account type.",
    email: "E-mail",
    password: "Password",
    consentPre: "I agree to the processing of my personal data by SauberEko s.r.o. for the purpose of the certification process and communication. (",
    privacy: "Privacy policy",
    createAccount: "Create account",
    enter: "Enter",
    working: "Working...",
    loginError: "Sign-in error.",
    logout: "Sign out",
    dangerTitle: "Delete account",
    dangerHint: "In accordance with GDPR (right to erasure), you can permanently delete your account and all related data — your application, uploaded files, signed documents, invoices and correspondence. This action is irreversible.",
    deleteBtn: "Delete my account",
    deleteConfirmTitle: "Permanently delete account?",
    deleteConfirmText: "Your entire account and all data will be deleted. This action cannot be undone. To confirm, type the word below",
    deleteConfirmWord: "DELETE",
    deleteTypePlaceholder: "Type DELETE",
    deleteCancel: "Cancel",
    deleteConfirmBtn: "Delete permanently",
    deleteDone: "Your account has been deleted. Thank you.",
    deleteErr: "Deletion failed. Please try again.",
    stSubmitted: "Application submitted",
    stApproved: "Approved",
    stPaid: "Fee paid",
    evidenceNo: "Registration number:",
    auditConfirmed: "Audit completed — approved",
    certifiedBadge: "Certificate issued — you are certified",
    feeTitle: "Registration fee",
    feeDesc1: "Your application has been approved. To continue the certification process, please pay the one-time registration fee of ",
    feeAmount: "€59.00 (incl. 23% VAT)",
    feeDesc2: ". An invoice will be sent automatically after payment.",
    payBtn: "Pay €59 by card",
    feeAmountCompany: "€490.00 (incl. 23% VAT)",
    payBtnCompany: "Pay €490 by card",
    redirecting: "Redirecting to payment...",
    verifying: "Verifying payment...",
    paySuccess: "Payment successful! The invoice has been e-mailed to you.",
    payFailed: "Payment could not be verified. Check your e-mail or try again.",
    payExpired: "Payment expired. Please try again.",
    paidNote: "The registration fee is paid. You can download your invoice.",
    downloadInvoice: "Download invoice (PDF)",
    invoiceErr: "Could not load the invoice.",
    docsTitle: "Documents to download",
    docsHint: "Send completed documents to info@saubereko.eu — or upload them below.",
    docPostup: "Certification process",
    docZiadost: "Certification application",
    docKodex: "Code of professional integrity",
    docSuhlas: "Personal data consent (GDPR)",
    docDownload: "Download",
    appTitle: "Application to start the certification process",
    appSubtitle: "Sa.Eko. — fill in the details and submit your application for review.",
    sec1: "1. Identification",
    sec2: "2. Field of activity & specialization",
    sec3: "3. Technical & professional background (self-audit)",
    sec4: "4. Declaration of alignment with the Sa.Eko. Code",
    fName: "Company name",
    fNameInd: "Full name",
    fIco: "Company ID",
    fBirth: "Date of birth",
    fIcoInd: "Business ID (if self-employed — optional)",
    fPhone: "Phone",
    fSeat: "Registered seat",
    fAddr: "Operating address",
    fCountry: "Country (billing)",
    fVatId: "Customer VAT ID (for EU companies)",
    fResponsible: "Responsible person (contact details)",
    fSpec: "Briefly describe the main activities for which you request certification",
    fWorkers: "Number of workers subject to certification",
    fEquip: "List of key technical equipment",
    fCerts: "Current certificates held (ISO, professional exams)",
    declKodex: "I confirm that I have fully read the “Code of Professional Integrity and Quality 2026” of SauberEko s.r.o.",
    declAudit: "I agree to undergo a professional audit and verification of my competencies/processes.",
    declPillars: "I commit to adhering to the 10 pillars of expertise and responsibility of Sa.Eko.",
    declUnderstanding: "I understand that the Sa.Eko. certificate results from a professionalism review and is not granted automatically.",
    submitNew: "Save and continue to signing documents",
    saveChanges: "Save changes",
    sending: "Sending...",
    appSavedNew: "Details saved. Now sign the documents below and finally send the complete application.",
    appSavedUpd: "Application updated.",
    approvedMsg: "Your application has been approved and included in the certification process. Our specialist will contact you within 14 business days.",
    regimeNonEu: "Outside the EU: the invoice will be issued without VAT (export of service).",
    regimeRc: "EU company with VAT ID: reverse charge applies.",
    regimeOss: "EU without VAT ID: the OSS regime applies.",
    upTitle: "Documents & video",
    upDesc: "Attach supporting materials (profile/CV, certificates, photo documentation) and a short verification video of your work.",
    upDoc: "Upload document",
    upVideo: "Upload video",
    upVideoReplace: "Replace video",
    upDocHint: "PDF, JPG, PNG, DOCX · max 15 MB",
    upVideoHint: "MP4, MOV, WEBM · max 100 MB",
    upUploading: "Uploading...",
    upTooBig: "File is too large",
    upFailed: "Upload failed.",
    upSubmitTitle: "Finished uploading?",
    upSubmitHint: "Once you've uploaded all materials, submit them for review. We'll send you a confirmation by e-mail.",
    upSubmitBtn: "Submit documents for audit",
    upSubmitting: "Submitting...",
    upSubmitDone: "Your documents have been submitted for review. We've sent you a confirmation by e-mail.",
    upSubmitErr: "Submission failed. Please try again.",
    confirmDelete: "Delete this file?",
  },
  de: {
    brand: "Sa.Eko. Zertifizierungsportal",
    register: "Antragsteller-Registrierung",
    login: "Anmelden",
    tabLogin: "Anmelden",
    tabRegister: "Registrieren",
    nameLabel: "Name / Firmenname",
    typeLabel: "Art des Antragstellers",
    individual: "Einzelperson",
    company: "Firma",
    individualHint: "Selbstständig",
    companyHint: "Firma (s.r.o. / GmbH)",
    switchTypeTitle: "Kontotyp",
    switchTypeHint: "Versehentlich als Firma oder Einzelperson registriert? Hier können Sie es korrigieren.",
    switchToCompany: "Zu Firma wechseln",
    switchToIndividual: "Zu Einzelperson wechseln",
    switchTypeCurrent: "Aktueller Typ:",
    switchTypeConfirm: "Möchten Sie den Kontotyp wirklich ändern? Antragsfelder und Gebühr werden entsprechend angepasst.",
    switchTypeLocked: "Der Kontotyp kann nicht mehr geändert werden (Antrag ist bezahlt oder genehmigt). Kontakt: kontakt@saubereko.eu.",
    switchTypeDone: "Kontotyp geändert.",
    switchTypeErr: "Kontotyp konnte nicht geändert werden.",
    email: "E-Mail",
    password: "Passwort",
    consentPre: "Ich stimme der Verarbeitung meiner personenbezogenen Daten durch SauberEko s.r.o. zum Zweck des Zertifizierungsverfahrens und der Kommunikation zu. (",
    privacy: "Datenschutz",
    createAccount: "Konto erstellen",
    enter: "Eintreten",
    working: "Arbeite...",
    loginError: "Anmeldefehler.",
    logout: "Abmelden",
    dangerTitle: "Konto löschen",
    dangerHint: "Gemäß DSGVO (Recht auf Löschung) können Sie Ihr Konto und alle zugehörigen Daten dauerhaft löschen — Antrag, hochgeladene Dateien, signierte Dokumente, Rechnungen und Korrespondenz. Diese Aktion ist unwiderruflich.",
    deleteBtn: "Mein Konto löschen",
    deleteConfirmTitle: "Konto dauerhaft löschen?",
    deleteConfirmText: "Ihr gesamtes Konto und alle Daten werden gelöscht. Diese Aktion kann nicht rückgängig gemacht werden. Zur Bestätigung geben Sie das folgende Wort ein",
    deleteConfirmWord: "LÖSCHEN",
    deleteTypePlaceholder: "LÖSCHEN eingeben",
    deleteCancel: "Abbrechen",
    deleteConfirmBtn: "Dauerhaft löschen",
    deleteDone: "Ihr Konto wurde gelöscht. Danke.",
    deleteErr: "Löschen fehlgeschlagen. Bitte erneut versuchen.",
    stSubmitted: "Antrag eingereicht",
    stApproved: "Genehmigt",
    stPaid: "Gebühr bezahlt",
    evidenceNo: "Registrierungsnummer:",
    auditConfirmed: "Audit abgeschlossen — genehmigt",
    certifiedBadge: "Zertifikat ausgestellt — Sie sind zertifiziert",
    feeTitle: "Registrierungsgebühr",
    feeDesc1: "Ihr Antrag wurde genehmigt. Um das Zertifizierungsverfahren fortzusetzen, zahlen Sie bitte die einmalige Registrierungsgebühr von ",
    feeAmount: "59,00 € (inkl. 23 % MwSt.)",
    feeDesc2: ". Nach der Zahlung senden wir Ihnen automatisch eine Rechnung.",
    payBtn: "59 € mit Karte zahlen",
    feeAmountCompany: "490,00 € (inkl. 23 % MwSt.)",
    payBtnCompany: "490 € mit Karte zahlen",
    redirecting: "Weiterleitung zur Zahlung...",
    verifying: "Zahlung wird überprüft...",
    paySuccess: "Zahlung erfolgreich! Die Rechnung wurde Ihnen per E-Mail gesendet.",
    payFailed: "Zahlung konnte nicht überprüft werden. Prüfen Sie Ihre E-Mail oder versuchen Sie es erneut.",
    payExpired: "Zahlung abgelaufen. Bitte erneut versuchen.",
    paidNote: "Die Registrierungsgebühr ist bezahlt. Sie können Ihre Rechnung herunterladen.",
    downloadInvoice: "Rechnung herunterladen (PDF)",
    invoiceErr: "Rechnung konnte nicht geladen werden.",
    docsTitle: "Dokumente zum Herunterladen",
    docsHint: "Ausgefüllte Dokumente an info@saubereko.eu senden — oder unten hochladen.",
    docPostup: "Zertifizierungsablauf",
    docZiadost: "Zertifizierungsantrag",
    docKodex: "Kodex der beruflichen Integrität",
    docSuhlas: "Einwilligung zur Datenverarbeitung (DSGVO)",
    docDownload: "Herunterladen",
    appTitle: "Antrag auf Beginn des Zertifizierungsprozesses",
    appSubtitle: "Sa.Eko. — füllen Sie die Angaben aus und senden Sie Ihren Antrag zur Prüfung.",
    sec1: "1. Identifikationsdaten",
    sec2: "2. Tätigkeitsbereich & Spezialisierung",
    sec3: "3. Technischer & fachlicher Hintergrund (Self-Audit)",
    sec4: "4. Erklärung zur Übereinstimmung mit dem Sa.Eko.-Kodex",
    fName: "Firmenname",
    fNameInd: "Vor- und Nachname",
    fIco: "Firmen-ID (IČO)",
    fBirth: "Geburtsdatum",
    fIcoInd: "Unternehmens-ID (falls selbstständig — optional)",
    fPhone: "Telefon",
    fSeat: "Firmensitz",
    fAddr: "Tätigkeitsadresse",
    fCountry: "Land (Rechnung)",
    fVatId: "USt-IdNr. des Kunden (für EU-Firmen)",
    fResponsible: "Verantwortliche Person (Kontaktdaten)",
    fSpec: "Beschreiben Sie kurz die Haupttätigkeiten, für die Sie eine Zertifizierung beantragen",
    fWorkers: "Anzahl der zu zertifizierenden Mitarbeiter",
    fEquip: "Liste der wichtigsten technischen Ausrüstung",
    fCerts: "Aktuell gehaltene Zertifikate (ISO, Fachprüfungen)",
    declKodex: "Ich bestätige, dass ich den „Kodex der beruflichen Integrität und Qualität 2026“ von SauberEko s.r.o. vollständig gelesen habe.",
    declAudit: "Ich stimme einem Fachaudit und der Überprüfung meiner Kompetenzen/Prozesse zu.",
    declPillars: "Ich verpflichte mich, die 10 Säulen der Fachkompetenz und Verantwortung von Sa.Eko. einzuhalten.",
    declUnderstanding: "Ich verstehe, dass das Sa.Eko.-Zertifikat das Ergebnis einer Professionalitätsprüfung ist und nicht automatisch gewährt wird.",
    submitNew: "Speichern und weiter zur Unterschrift",
    saveChanges: "Änderungen speichern",
    sending: "Senden...",
    appSavedNew: "Angaben gespeichert. Unterschreiben Sie jetzt die Dokumente unten und senden Sie zum Schluss den vollständigen Antrag.",
    appSavedUpd: "Antrag aktualisiert.",
    approvedMsg: "Ihr Antrag wurde genehmigt und in das Zertifizierungsverfahren aufgenommen. Unser Experte wird Sie innerhalb von 14 Werktagen kontaktieren.",
    regimeNonEu: "Außerhalb der EU: Die Rechnung wird ohne MwSt. ausgestellt (Dienstleistungsexport).",
    regimeRc: "EU-Firma mit USt-IdNr.: Reverse-Charge-Verfahren wird angewendet.",
    regimeOss: "EU ohne USt-IdNr.: OSS-Regelung wird angewendet.",
    upTitle: "Dokumente & Video",
    upDesc: "Fügen Sie Unterlagen bei (Profil/Lebenslauf, Zertifikate, Fotodokumentation) und ein kurzes Verifizierungsvideo Ihrer Arbeit.",
    upDoc: "Dokument hochladen",
    upVideo: "Video hochladen",
    upVideoReplace: "Video ersetzen",
    upDocHint: "PDF, JPG, PNG, DOCX · max. 15 MB",
    upVideoHint: "MP4, MOV, WEBM · max. 100 MB",
    upUploading: "Hochladen...",
    upTooBig: "Datei ist zu groß",
    upFailed: "Upload fehlgeschlagen.",
    upSubmitTitle: "Hochladen abgeschlossen?",
    upSubmitHint: "Wenn Sie alle Unterlagen hochgeladen haben, senden Sie sie zur Prüfung. Wir senden Ihnen eine Bestätigung per E-Mail.",
    upSubmitBtn: "Unterlagen zum Audit senden",
    upSubmitting: "Senden...",
    upSubmitDone: "Ihre Unterlagen wurden zur Prüfung gesendet. Wir haben Ihnen eine Bestätigung per E-Mail gesendet.",
    upSubmitErr: "Senden fehlgeschlagen. Bitte erneut versuchen.",
    confirmDelete: "Diese Datei löschen?",
  },
};

// PL — Polish portal translation
PT.pl = {
  brand: "Portal certyfikacji Sa.Eko.",
  register: "Rejestracja wnioskodawcy",
  login: "Logowanie",
  tabLogin: "Zaloguj się",
  tabRegister: "Zarejestruj się",
  nameLabel: "Imię i nazwisko / Nazwa firmy",
  typeLabel: "Typ wnioskodawcy",
  individual: "Osoba fizyczna",
  company: "Firma",
  individualHint: "Samozatrudniony (JDG)",
  companyHint: "Firma (s.r.o. / Sp. z o.o.)",
  switchTypeTitle: "Typ konta",
  switchTypeHint: "Zarejestrowałeś się przez pomyłkę jako firma lub osoba fizyczna? Tutaj możesz to poprawić.",
  switchToCompany: "Przełącz na Firmę",
  switchToIndividual: "Przełącz na Osobę fizyczną",
  switchTypeCurrent: "Aktualny typ:",
  switchTypeConfirm: "Czy na pewno chcesz zmienić typ konta? Pola wniosku i opłata zostaną odpowiednio dostosowane.",
  switchTypeLocked: "Typu konta nie można już zmienić (wniosek opłacony lub zatwierdzony). Kontakt: kontakt@saubereko.eu.",
  switchTypeDone: "Typ konta został zmieniony.",
  switchTypeErr: "Nie udało się zmienić typu konta.",
  email: "E-mail",
  password: "Hasło",
  consentPre: "Wyrażam zgodę na przetwarzanie moich danych osobowych przez SauberEko s.r.o. w celu procedury certyfikacyjnej i komunikacji. (",
  privacy: "Ochrona danych",
  createAccount: "Utwórz konto",
  enter: "Wejdź",
  working: "Pracuję...",
  loginError: "Błąd logowania.",
  logout: "Wyloguj",
    dangerTitle: "Usuń konto",
    dangerHint: "Zgodnie z RODO (prawo do usunięcia) możesz trwale usunąć swoje konto i wszystkie powiązane dane — wniosek, przesłane pliki, podpisane dokumenty, faktury i korespondencję. Ta czynność jest nieodwracalna.",
    deleteBtn: "Usuń moje konto",
    deleteConfirmTitle: "Trwale usunąć konto?",
    deleteConfirmText: "Całe Twoje konto i wszystkie dane zostaną usunięte. Tej czynności nie można cofnąć. Aby potwierdzić, wpisz poniższe słowo",
    deleteConfirmWord: "USUŃ",
    deleteTypePlaceholder: "Wpisz USUŃ",
    deleteCancel: "Anuluj",
    deleteConfirmBtn: "Usuń trwale",
    deleteDone: "Twoje konto zostało usunięte. Dziękujemy.",
    deleteErr: "Usuwanie nie powiodło się. Spróbuj ponownie.",
  stSubmitted: "Wniosek złożony",
  stApproved: "Zatwierdzony",
  stPaid: "Opłata uiszczona",
  evidenceNo: "Numer ewidencyjny:",
  auditConfirmed: "Audyt zakończony — zatwierdzono",
  certifiedBadge: "Certyfikat wydany — jesteś certyfikowany",
  feeTitle: "Opłata rejestracyjna",
  feeDesc1: "Twój wniosek został zatwierdzony. Aby kontynuować procedurę certyfikacyjną, uiść jednorazową opłatę rejestracyjną ",
  feeAmount: "59,00 € (z VAT 23 %)",
  feeDesc2: ". Po dokonaniu płatności automatycznie wyślemy fakturę.",
  payBtn: "Zapłać 59 € kartą",
  feeAmountCompany: "490,00 € (z VAT 23 %)",
  payBtnCompany: "Zapłać 490 € kartą",
  redirecting: "Przekierowuję do płatności...",
  verifying: "Weryfikuję płatność...",
  paySuccess: "Płatność zakończona pomyślnie! Faktura została wysłana na Twój e-mail.",
  payFailed: "Nie udało się zweryfikować płatności. Sprawdź e-mail lub spróbuj ponownie.",
  payExpired: "Płatność wygasła. Spróbuj ponownie.",
  paidNote: "Opłata rejestracyjna jest uiszczona. Możesz pobrać fakturę.",
  downloadInvoice: "Pobierz fakturę (PDF)",
  invoiceErr: "Nie udało się wczytać faktury.",
  docsTitle: "Dokumenty do pobrania",
  docsHint: "Wypełnione dokumenty wyślij na info@saubereko.eu — lub prześlij je poniżej.",
  docPostup: "Proces certyfikacji",
  docZiadost: "Wniosek o certyfikację",
  docKodex: "Kodeks integralności zawodowej",
  docSuhlas: "Zgoda na przetwarzanie danych (RODO)",
  docDownload: "Pobierz",
  appTitle: "Wniosek o rozpoczęcie procesu certyfikacji",
  appSubtitle: "Sa.Eko. — wypełnij dane i prześlij wniosek do oceny.",
  sec1: "1. Dane identyfikacyjne",
  sec2: "2. Obszar działalności i specjalizacja",
  sec3: "3. Zaplecze techniczne i zawodowe (samoaudyt)",
  sec4: "4. Oświadczenie o zgodności z Kodeksem Sa.Eko.",
  fName: "Nazwa firmy",
  fNameInd: "Imię i nazwisko",
  fIco: "REGON/NIP (IČO)",
  fBirth: "Data urodzenia",
  fIcoInd: "REGON/NIP (jeśli samozatrudniony — opcjonalne)",
  fPhone: "Telefon",
  fSeat: "Siedziba",
  fAddr: "Adres działalności",
  fCountry: "Kraj (fakturowanie)",
  fVatId: "Numer VAT odbiorcy (dla firm z UE)",
  fResponsible: "Osoba odpowiedzialna (dane kontaktowe)",
  fSpec: "Krótko opisz główne czynności, dla których ubiegasz się o certyfikację",
  fWorkers: "Liczba pracowników podlegających certyfikacji",
  fEquip: "Wykaz kluczowego wyposażenia technicznego",
  fCerts: "Aktualnie posiadane certyfikaty (ISO, egzaminy zawodowe)",
  declKodex: "Potwierdzam, że w pełni zapoznałem się z dokumentem „Kodeks integralności zawodowej i jakości 2026” spółki SauberEko s.r.o.",
  declAudit: "Zgadzam się na przeprowadzenie audytu eksperckiego oraz weryfikację moich kompetencji/procesów.",
  declPillars: "Zobowiązuję się przestrzegać 10 filarów fachowości i odpowiedzialności Sa.Eko.",
  declUnderstanding: "Rozumiem, że certyfikat Sa.Eko. jest wynikiem weryfikacji profesjonalizmu i nie jest przyznawany automatycznie.",
  submitNew: "Zapisz i przejdź do podpisu dokumentów",
  saveChanges: "Zapisz zmiany",
  sending: "Wysyłam...",
  appSavedNew: "Dane zapisane. Teraz podpisz dokumenty poniżej, a na końcu wyślij kompletny wniosek.",
  appSavedUpd: "Wniosek został zaktualizowany.",
  approvedMsg: "Twój wniosek został zatwierdzony i włączony do procedury certyfikacyjnej. Nasz gwarant skontaktuje się z Tobą w ciągu 14 dni roboczych.",
  regimeNonEu: "Poza UE: faktura zostanie wystawiona bez VAT (eksport usługi).",
  regimeRc: "Firma z UE z numerem VAT: stosuje się odwrotne obciążenie (Reverse charge).",
  regimeOss: "UE bez numeru VAT: stosuje się procedurę OSS.",
  upTitle: "Dokumenty i wideo",
  upDesc: "Załącz materiały do wniosku (profil/CV, certyfikaty, dokumentację fotograficzną) oraz krótkie wideo weryfikacyjne Twojej pracy.",
  upDoc: "Prześlij dokument",
  upVideo: "Prześlij wideo",
  upVideoReplace: "Zamień wideo",
  upDocHint: "PDF, JPG, PNG, DOCX · maks. 15 MB",
  upVideoHint: "MP4, MOV, WEBM · maks. 100 MB",
  upUploading: "Przesyłam...",
  upTooBig: "Plik jest zbyt duży",
  upFailed: "Przesyłanie nie powiodło się.",
  upSubmitTitle: "Zakończono przesyłanie?",
  upSubmitHint: "Po przesłaniu wszystkich materiałów wyślij je do oceny. Potwierdzenie prześlemy e-mailem.",
  upSubmitBtn: "Wyślij materiały do audytu",
  upSubmitting: "Wysyłam...",
  upSubmitDone: "Twoje materiały zostały wysłane do oceny. Potwierdzenie wysłaliśmy e-mailem.",
  upSubmitErr: "Wysyłanie nie powiodło się. Spróbuj ponownie.",
  confirmDelete: "Usunąć ten plik?",
};

// E-signature section labels (4 languages)
Object.assign(PT.sk, {
  signTitle: "Elektronický podpis dokumentov",
  signHint: "Vytvorte si podpis raz. Pri každom dokumente si ho otvorte, prečítajte a podpíšte. Nakoniec potvrďte oboznámenie a odošlite kompletnú žiadosť.",
  signRead: "Prečítať",
  signConfirm: "Potvrdzujem, že som si všetky dokumenty otvoril, prečítal a podpísal, a oboznámil som sa s ich obsahom.",
  signSubmit: "Odoslať kompletnú žiadosť",
  fillFormFirst: "Doplňte prosím v žiadosti vyššie všetky povinné údaje a vyhlásenia.",
  submitFinalHint: "Posledný krok — po podpísaní všetkých dokumentov a pridaní príloh odošlite kompletnú žiadosť. Zmeny vo formulári sa uložia spolu s odoslaním.",
  savedPending: "Údaje sú uložené. Teraz podpíšte dokumenty nižšie a nakoniec odošlite kompletnú žiadosť. Zmeny vo formulári sa uložia spolu s odoslaním.",
  signSubmitted: "Ďakujeme! Vaša kompletná žiadosť bola odoslaná. Na e-mail Vám príde potvrdenie o prijatí. Žiadosť posúdime a do 14 dní Vám zašleme rozhodnutie o zaradení do konania.",
  signAllToSubmit: "Najprv otvorte, prečítajte a podpíšte všetky dokumenty vyššie.",
  signPadHint: "Podpíšte sa myšou alebo prstom v poli nižšie.",
  signSave: "Uložiť podpis",
  signClear: "Vymazať",
  signSaved: "Podpis uložený",
  signChange: "Zmeniť podpis",
  signNeedFirst: "Najprv si vytvorte a uložte podpis.",
  signSaveErr: "Podpis sa nepodarilo uložiť.",
  signBtn: "Podpísať",
  signResign: "Podpísať znova",
  signView: "Zobraziť",
  signedOn: "Podpísané dňa",
});
Object.assign(PT.en, {
  signTitle: "Electronic document signing",
  signHint: "Create your signature once. Open, read and sign each document. Finally, confirm you have read them and submit the complete application.",
  signRead: "Read",
  signConfirm: "I confirm that I have opened, read and signed all documents, and I am familiar with their content.",
  signSubmit: "Submit complete application",
  fillFormFirst: "Please complete all required details and declarations in the application above.",
  submitFinalHint: "Final step — after signing all documents and adding attachments, send the complete application. Changes in the form are saved together with sending.",
  savedPending: "Details saved. Now sign the documents below and finally send the complete application. Changes in the form are saved together with sending.",
  signSubmitted: "Thank you! Your complete application has been sent. You will receive a confirmation of receipt by e-mail. We will assess it and send you the decision on admission to the proceedings within 14 days.",
  signAllToSubmit: "First open, read and sign all documents above.",
  signPadHint: "Sign with your mouse or finger in the field below.",
  signSave: "Save signature",
  signClear: "Clear",
  signSaved: "Signature saved",
  signChange: "Change signature",
  signNeedFirst: "Please create and save your signature first.",
  signSaveErr: "Could not save the signature.",
  signBtn: "Sign",
  signResign: "Sign again",
  signView: "View",
  signedOn: "Signed on",
});
Object.assign(PT.de, {
  signTitle: "Elektronische Dokumentensignatur",
  signHint: "Erstellen Sie Ihre Unterschrift einmal. Öffnen, lesen und signieren Sie jedes Dokument. Bestätigen Sie zum Schluss die Kenntnisnahme und senden Sie den vollständigen Antrag ab.",
  signRead: "Lesen",
  signConfirm: "Ich bestätige, dass ich alle Dokumente geöffnet, gelesen und unterschrieben habe und mit ihrem Inhalt vertraut bin.",
  signSubmit: "Vollständigen Antrag absenden",
  fillFormFirst: "Bitte füllen Sie oben im Antrag alle Pflichtangaben und Erklärungen aus.",
  submitFinalHint: "Letzter Schritt — nach Unterschrift aller Dokumente und Hinzufügen der Anlagen senden Sie den vollständigen Antrag. Änderungen im Formular werden beim Absenden gespeichert.",
  savedPending: "Angaben gespeichert. Unterschreiben Sie jetzt die Dokumente unten und senden Sie zum Schluss den vollständigen Antrag. Änderungen werden beim Absenden gespeichert.",
  signSubmitted: "Vielen Dank! Ihr vollständiger Antrag wurde gesendet. Sie erhalten eine Eingangsbestätigung per E-Mail. Wir prüfen den Antrag und senden Ihnen innerhalb von 14 Tagen die Entscheidung über die Aufnahme in das Verfahren.",
  signAllToSubmit: "Öffnen, lesen und signieren Sie zuerst alle Dokumente oben.",
  signPadHint: "Unterschreiben Sie mit Maus oder Finger im Feld unten.",
  signSave: "Unterschrift speichern",
  signClear: "Löschen",
  signSaved: "Unterschrift gespeichert",
  signChange: "Unterschrift ändern",
  signNeedFirst: "Bitte erstellen und speichern Sie zuerst Ihre Unterschrift.",
  signSaveErr: "Unterschrift konnte nicht gespeichert werden.",
  signBtn: "Signieren",
  signResign: "Erneut signieren",
  signView: "Ansehen",
  signedOn: "Signiert am",
});
Object.assign(PT.pl, {
  signTitle: "Elektroniczny podpis dokumentów",
  signHint: "Utwórz podpis raz. Otwórz, przeczytaj i podpisz każdy dokument. Na koniec potwierdź zapoznanie się i wyślij kompletny wniosek.",
  signRead: "Przeczytaj",
  signConfirm: "Potwierdzam, że otworzyłem, przeczytałem i podpisałem wszystkie dokumenty oraz zapoznałem się z ich treścią.",
  signSubmit: "Wyślij kompletny wniosek",
  fillFormFirst: "Uzupełnij powyżej we wniosku wszystkie wymagane dane i oświadczenia.",
  submitFinalHint: "Ostatni krok — po podpisaniu wszystkich dokumentów i dodaniu załączników wyślij kompletny wniosek. Zmiany w formularzu zapiszą się razem z wysłaniem.",
  savedPending: "Dane zapisane. Teraz podpisz dokumenty poniżej, a na końcu wyślij kompletny wniosek. Zmiany zapiszą się razem z wysłaniem.",
  signSubmitted: "Dziękujemy! Twój kompletny wniosek został wysłany. Otrzymasz e-mailem potwierdzenie przyjęcia. Ocenimy wniosek i w ciągu 14 dni prześlemy decyzję o włączeniu do postępowania.",
  signAllToSubmit: "Najpierw otwórz, przeczytaj i podpisz wszystkie dokumenty powyżej.",
  signPadHint: "Podpisz się myszą lub palcem w polu poniżej.",
  signSave: "Zapisz podpis",
  signClear: "Wyczyść",
  signSaved: "Podpis zapisany",
  signChange: "Zmień podpis",
  signNeedFirst: "Najpierw utwórz i zapisz swój podpis.",
  signSaveErr: "Nie udało się zapisać podpisu.",
  signBtn: "Podpisz",
  signResign: "Podpisz ponownie",
  signView: "Zobacz",
  signedOn: "Podpisano dnia",
});

// "How to proceed" guide + order enforcement labels (4 languages)
Object.assign(PT.sk, {
  howToTitle: "Ako postupovať",
  howToSteps: [
    "Vyplňte a uložte žiadosť o certifikáciu vo formulári nižšie.",
    "Vytvorte si elektronický podpis — stačí raz.",
    "Podpíšte predvyplnené dokumenty — automaticky sa odošlú značke profesionality a odbornosti SauberEko®.",
    "Sledujte stav žiadosti a sťahujte si potvrdenia priamo tu v profile.",
  ],
  signNeedApp: "Najprv vyplňte a uložte žiadosť o certifikáciu (formulár vyššie). Potom môžete podpísať dokumenty a odoslať ich nám.",
});
Object.assign(PT.en, {
  howToTitle: "How to proceed",
  howToSteps: [
    "Fill in and save the certification application in the form below.",
    "Create your electronic signature — only once.",
    "Sign the pre-filled documents — they are sent to SauberEko® automatically.",
    "Track your application status and download confirmations right here in your profile.",
  ],
  signNeedApp: "Please fill in and save the certification application first (the form above). Then you can sign the documents and send them to us.",
});
Object.assign(PT.de, {
  howToTitle: "So gehen Sie vor",
  howToSteps: [
    "Füllen Sie den Zertifizierungsantrag im Formular unten aus und speichern Sie ihn.",
    "Erstellen Sie Ihre elektronische Unterschrift — nur einmal.",
    "Signieren Sie die vorausgefüllten Dokumente — sie werden automatisch an SauberEko® gesendet.",
    "Verfolgen Sie den Status Ihres Antrags und laden Sie Bestätigungen direkt hier im Profil herunter.",
  ],
  signNeedApp: "Bitte füllen Sie zuerst den Zertifizierungsantrag aus und speichern Sie ihn (Formular oben). Danach können Sie die Dokumente signieren und an uns senden.",
});
Object.assign(PT.pl, {
  howToTitle: "Jak postępować",
  howToSteps: [
    "Wypełnij i zapisz wniosek o certyfikację w formularzu poniżej.",
    "Utwórz swój podpis elektroniczny — wystarczy raz.",
    "Podpisz wstępnie wypełnione dokumenty — są automatycznie wysyłane do SauberEko®.",
    "Śledź status wniosku i pobieraj potwierdzenia bezpośrednio w swoim profilu.",
  ],
  signNeedApp: "Najpierw wypełnij i zapisz wniosek o certyfikację (formularz powyżej). Następnie możesz podpisać dokumenty i wysłać je do nas.",
});
